import React from 'react'
import { getExternalLinkProps } from '../../utils/externalLink'

export type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>

/**
 * Drop-in replacement for `<a>`. External hrefs open in a new tab with
 * `rel="noopener noreferrer"`; relative and same-host hrefs behave exactly like a
 * plain `<a>`.
 *
 * Don't pass `target`/`rel` for external links — they are derived. The one exception is a
 * same-host link that must still open in a new tab (e.g. Terms during sign-up, so the form
 * isn't lost): give it an explicit `target="_blank"` and it is passed through untouched.
 * Links to our redirect worker (go.chirpyest.com) keep the Referer: `rel` is `noopener` only.
 */
const Anchor = React.forwardRef<HTMLAnchorElement, AnchorProps>(
  ({ href, target, rel, children, ...rest }, ref) => (
    <a
      ref={ref}
      href={href}
      {...getExternalLinkProps(href, { target, rel })}
      {...rest}
    >
      {children}
    </a>
  )
)

Anchor.displayName = 'Anchor'

export default Anchor
